import {
  BaseHubInlineBlockOptions,
  BaseHubInlineBlock as PrimitiveBaseHubInlineBlock,
} from '@basehub/tiptap-api-utils'
import { BasehubMarkClickPlugin } from './view/basehub-mark-handler'

export const BaseHubInlineBlock = PrimitiveBaseHubInlineBlock.extend<
  BaseHubInlineBlockOptions & {
    onClickBasehubInstanceMark: (id: string) => void
  }
>({
  addProseMirrorPlugins() {
    return [
      BasehubMarkClickPlugin({
        type: this.name,
        pluginKey: 'basehub-mark-click',
        onClickInstance: this.options.onClickBasehubInstanceMark,
      }),
    ]
  },
})
